import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Check, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SiteNavBar from '@/components/SiteNavBar';
import Footer from '@/components/Footer';

const AgenciesFlyWebThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const businessName = searchParams.get('business') || '';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Helmet>
        <title>Thank You | Fly Web for Agencies</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <SiteNavBar />

      <div className="pt-32 pb-24 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 rounded-full bg-green-500/20 border-2 border-green-500/40 flex items-center justify-center mx-auto mb-8 animate-pulse">
            <Check className="w-10 h-10 text-green-400" />
          </div>

          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Thank You!
          </h1>
          {businessName && (
            <p className="text-xl text-green-400 mb-4">
              We received your inquiry for <span className="font-semibold">{businessName}</span>
            </p>
          )}
          <p className="text-lg text-gray-400 mb-12 max-w-lg mx-auto">
            Our agency partnerships team will review your inquiry and get back to you within 24 hours.
          </p>

          <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-8 mb-10 text-left">
            <h2 className="text-xl font-semibold mb-6 text-center">What Happens Next?</h2>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-green-500/20 border border-green-500/30 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-green-400 text-sm font-bold">1</span>
                </div>
                <div>
                  <p className="font-medium text-white">Partnership Review</p>
                  <p className="text-gray-400 text-sm">We'll review your agency profile and understand your client needs</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-green-500/20 border border-green-500/30 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-green-400 text-sm font-bold">2</span>
                </div>
                <div>
                  <p className="font-medium text-white">White-Label Demo</p>
                  <p className="text-gray-400 text-sm">We'll set up a personalized demo of the Fly Web platform with your branding</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-green-500/20 border border-green-500/30 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-green-400 text-sm font-bold">3</span>
                </div>
                <div>
                  <p className="font-medium text-white">Onboarding</p>
                  <p className="text-gray-400 text-sm">Get set up with your agency dashboard, custom domain, and first client locations</p>
                </div>
              </div>
            </div>
          </div>

          <Link to="/agencies-fly-web">
            <Button size="lg" className="bg-gray-800 border border-gray-700 text-white hover:bg-gray-700 rounded-xl px-6">
              <ArrowLeft className="w-5 h-5 mr-2" />
              Back to Fly Web for Agencies
            </Button>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AgenciesFlyWebThankYouPage;
